import React, { useEffect, useRef } from 'react';
import './HeroSection.css';

const STATS = [
  { icon: 'fa-solid fa-book-open',  value: '50,000+', label: 'Books & Journals' },
  { icon: 'fa-solid fa-users',       value: '10,000+', label: 'Active Members'   },
  { icon: 'fa-solid fa-building-columns', value: '25+', label: 'Years of Service' },
  { icon: 'fa-solid fa-laptop',     value: '200+',     label: 'Digital Resources' },
];

export default function HeroSection({ onLoginClick }) {
  const titleRef = useRef(null);

  /* ── Parallax on scroll ── */
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const bg = document.querySelector('.hero__bg');
      if (bg) bg.style.transform = `translateY(${scrollY * 0.35}px)`;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="home" className="hero">

      {/* ── Background image with parallax ── */}
      <div className="hero__bg" />

      {/* ── Multi-layer overlay ── */}
      <div className="hero__overlay" />
      <div className="hero__overlay hero__overlay--gradient" />

      {/* ── Decorative floating orbs ── */}
      <div className="hero__orb hero__orb--1" />
      <div className="hero__orb hero__orb--2" />
      <div className="hero__orb hero__orb--3" />

      {/* ── Main content ── */}
      <div className="hero__content" ref={titleRef}>

        {/* Eyebrow badge */}
        <div className="hero__badge">
          <i className="fa-solid fa-star"></i>
          <span>Welcome to Dr. SS Johl Library</span>
        </div>

        {/* Headline */}
        <h1 className="hero__title">
          Your Gateway to<br />
          <span className="hero__title-highlight">Infinite Knowledge</span>
        </h1>

        {/* Subtitle */}
        <p className="hero__subtitle">
          A world-class library offering thousands of books, digital resources,
          research journals, and a peaceful space dedicated to learning and discovery.
        </p>

        {/* CTAs */}
        <div className="hero__actions">
          <a href="#about" className="hero__btn hero__btn--primary" onClick={(e) => {
            e.preventDefault();
            document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
          }}>
            <i className="fa-solid fa-compass"></i>
            Explore Library
          </a>
          <button className="hero__btn hero__btn--secondary" onClick={onLoginClick}>
            <i className="fa-solid fa-right-to-bracket"></i>
            Member Login
          </button>
        </div>

        {/* Scroll cue */}
        <div className="hero__scroll-cue">
          <span>Scroll to discover</span>
          <div className="hero__scroll-dot">
            <div className="hero__scroll-dot-inner" />
          </div>
        </div>
      </div>

      {/* ── Stats bar ── */}
      <div className="hero__stats">
        <div className="hero__stats-inner">
          {STATS.map((s, i) => (
            <div className="hero__stat" key={i}>
              <div className="hero__stat-icon">
                <i className={s.icon}></i>
              </div>
              <div className="hero__stat-text">
                <strong className="hero__stat-value">{s.value}</strong>
                <span className="hero__stat-label">{s.label}</span>
              </div>
              {i < STATS.length - 1 && <div className="hero__stat-divider" />}
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}
